(() => {
  'use strict';
  if (window.verumaDispatchDateLoaded) return;
  window.verumaDispatchDateLoaded = true;
  const selector = '.delivery-estimation-date-buy_buttons';
  function update() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const spanish = /^\/es(?:\/|$)/.test(location.pathname) || document.documentElement.lang.startsWith('es');
    const day = tomorrow.getDate();
    const lastTwo = day % 100;
    const suffix = lastTwo >= 11 && lastTwo <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
    const text = spanish
      ? new Intl.DateTimeFormat('es', { day: 'numeric', month: 'long' }).format(tomorrow)
      : new Intl.DateTimeFormat('en-US', { month: 'long' }).format(tomorrow) + ' ' + day + suffix;
    document.querySelectorAll(selector).forEach(el => {
      if (el.textContent !== text) el.textContent = text;
    });
  }
  update();
  if (!document.querySelector(selector)) return;
  window.setInterval(update, 60000);
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  document.addEventListener('shopify:section:load', update);
})();
